import React, { Children, useEffect, useState } from "react";
import Oval from "react-loading-icons/dist/esm/components/oval";
import { useDispatch, useSelector } from "react-redux";
import { ChangeoutputPinState } from "../../../../../../store/service-actions"
import Card from "../../../../Cards/Card";

import classes from "./PinOutput.module.css";

import InactiveIcon from "../../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/Pin/default - Off.svg";
import HiddenIcon from "../../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/HiddenPin.svg";

import pulseIcon from "../../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/Pin/__Switch - Pulse.png";
import pulseIconOn from "../../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/Pin/__Switch - Pulse - On.png";
import { switchPulse } from "../../../../../../Api Methods/Api";
import useUnixTimestampConverter from "../../../../../hooks/UseUnixTimestampConverter";
import useTimeDifference from "../../../../../hooks/UseTimeDifference";

import LockIcon from "../../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/DropDown Icons/__Locked.svg"
import HolidayModeWarningDialog from "./HolidayModeWarningDialog";

const PinOutputPulseSocket = ({ OutPutPin, SmartLock, holidayModeActive, linkedIntegrationIcon }) => {
    // console.log("Pulse");
    const dispatch = useDispatch();
    const client = useSelector(state => state.auth.client);
    const token = useSelector(state => state.auth.token);
    const userID = useSelector(state => state.auth.userID);

    const { pinName, pinStatusOff, pinStatusOn, pinState, icon, DeviceUUID, Pin, active, type, DeviceType, length, lastSwitchTime } = OutPutPin;
    const actionOneOnLabel = OutPutPin.actionOneOnLabel || "arm";
    const lowerCaseStringIcon = icon?.toLowerCase();
    const image = lowerCaseStringIcon + " - Off";
    const otherStateImage = icon + " - On";
    const staticPath = "/assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/";

    const imageFromPath = `${process.env.PUBLIC_URL}${staticPath}${image}.svg`
    let otherStateImageFromPath = `${process.env.PUBLIC_URL}${staticPath}${otherStateImage}.svg`;

    const [PinState, setPinState] = useState();
    const [timeLeft, setTimeLeft] = useState();
    const [buttonClicked, setButtonClicked] = useState(false)
    const [pinStateLoading, setPinStateLoading] = useState(false);

    //change timer state

    const startPulseTimer = (time) => {
        setTimeLeft(time || length);
        setPinState(prevPinState => !prevPinState);
        let timer = setInterval(() => {
            setTimeLeft(prevTimeLeft => {
                if (prevTimeLeft <= 1) {
                    clearInterval(timer);
                    setPinState((prevPinState) => !prevPinState);
                    setButtonClicked(false)
                    return 0; // Ensure timeLeft doesn't go below zero
                } else {
                    return prevTimeLeft - 1;
                }
            })
        }, 1000)

    }

    const [showHolidayWarning, setShowHolidayWarning] = useState(false);

    const performPinClick = async () => {
        setPinStateLoading(true);
        setButtonClicked(true);

        const apiData = {
            token,
            client,
        }

        const response = await switchPulse(apiData, userID, Pin, length * 1000, DeviceUUID, type, dispatch)
        if (response.pulse == "sent") {
            startPulseTimer();
            setPinStateLoading(false);
        } else {
            setPinStateLoading(false);
        }
    }

    const HandlePinClick = () => {
        if (holidayModeActive) {
            setShowHolidayWarning(true);
        } else {
            performPinClick();
        }
    }

    const HandleConfirmHolidayWarning = () => {
        setShowHolidayWarning(false);
        performPinClick();
    }

    //-- Starts (or resumes) the pulse animation only while we're still within the
    //-- lastSwitchTime + length window, whether lastSwitchTime came from a fresh
    //-- socket-detected change or a REST fetch on mount/reconnect.
    useEffect(() => {
        const datePulseClicked = new Date(lastSwitchTime * 1000)
        const datePulseFinished = new Date(lastSwitchTime * 1000).setSeconds(datePulseClicked.getSeconds() + length)
        var now = Date.now()
        let difference;

        if (!buttonClicked && now < datePulseFinished) {
            setButtonClicked(true)
            difference = Math.round((datePulseFinished - now) / 1000)
            startPulseTimer(difference)
        }

    }, [lastSwitchTime, pinState])

    return (
        <>
        <HolidayModeWarningDialog
            visible={showHolidayWarning}
            onConfirm={HandleConfirmHolidayWarning}
            onCancel={() => setShowHolidayWarning(false)}
        />
        <button className={`${classes["pin-switch"]} ${!active && classes["disabled-hover"]}`} style={{ opacity: !active && "30%", backgroundColor: SmartLock != null && "var(--PinLockColor)" }} disabled={buttonClicked || SmartLock != null} onClick={HandlePinClick}>
            {!active &&
                <div className={classes["overlay"]}>
                </div>}
            {PinState && (
                <div className={classes.overlay} style={{ backgroundColor: "rgba(0,0,0,0.45)", pointerEvents: "none" }}>
                    <div style={{ position: "relative", display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <Oval stroke="rgb(195, 12, 18)" strokeWidth={3} width={54} height={54} />
                        <span style={{ position: "absolute", color: "white", fontSize: "18px", fontWeight: "600" }}>{timeLeft}</span>
                    </div>
                </div>
            )}


            <div className={classes.top}>
                <h3 className={classes.pinName} style={{color:"#737373", fontWeight:"450", marginBottom:"5px"}}>{pinName}</h3>
                <div className={classes.topRightIconGroup}>
                    <img className={classes.pinIconTopRight} src={PinState ? pulseIconOn : pulseIcon} />
                </div>

                {SmartLock == null && linkedIntegrationIcon && (
                    <img
                        src={linkedIntegrationIcon}
                        alt="Linked integration"
                        title="Linked to an integration"
                        style={{ position: "absolute", top: "40px", right: "8px", width: "22px", height: "22px", objectFit: "contain" }}
                    />
                )}

                {SmartLock == null && (
                    <>
                        {!buttonClicked && active && (
                            <p className={classes.clickToText}>
                                Click to pulse{length ? ` for ${length >= 60 ? `${Math.floor(length / 60)}m${length % 60 > 0 ? ` ${length % 60}s` : ''}` : `${length}s`}` : ''}
                            </p>
                        )}
                    </>
                )}
            </div>

            {SmartLock != null ?
                <div className={classes.bottom}>
                    <img className={classes.LockIcon} src={LockIcon} />
                </div>
                :
                <div className={classes.bottom} />
            }
        </button>
        </>
    );
}

export default PinOutputPulseSocket;